<template>


  <el-form label-position="left" label-width="auto" size="small">
    <el-collapse :accordion="true">
      <el-collapse-item name="事件" title="事件">
        <el-form-item label="超链接">
          <el-input v-model="ele.option.url"></el-input>
        </el-form-item>

        <el-form-item label="鼠标样式">
          <el-select v-model="ele.option.cursor">
            <el-option value="default" label="默认光标"></el-option>
            <el-option value="crosshair" label="十字线"></el-option>
            <el-option value="pointer" label="链接"></el-option>
            <el-option value="move" label="可移动"></el-option>
            <el-option value="text" label="文本"></el-option>
            <el-option value="help" label="帮助"></el-option>
            <el-option value="" label=""></el-option>
          </el-select>
        </el-form-item>

      </el-collapse-item>
      <el-collapse-item name="字体" title="字体">
        <el-form-item label="背景色">
          <el-color-picker v-model="ele.option.backgroundColor" show-alpha
                           :predefine="['rgba(255, 255, 255, 1.0)','#ff4500',  '#ff8c00',  '#ffd700', '#90ee90',  '#00ced1', '#1e90ff',  '#c71585',  'rgba(255, 69, 0, 0.68)',  'rgb(255, 120, 0)',  'hsv(51, 100, 98)', 'hsva(120, 40, 94, 0.5)', 'hsl(181, 100%, 37%)', 'hsla(209, 100%, 56%, 0.73)','#c7158577']">
          </el-color-picker>
        </el-form-item>

        <el-form-item label="标题">
          <el-input v-model="ele.option.title"></el-input>
        </el-form-item>

        <el-form-item label="文本">
          <el-input v-model="ele.option.text"></el-input>
        </el-form-item>

        <el-form-item label="后缀">
          <el-input v-model="ele.option.suffix"></el-input>
        </el-form-item>

        <el-form-item label="文本颜色">
          <el-color-picker v-model="ele.option.color" show-alpha
                           :predefine="['rgba(255, 255, 255, 1.0)','#ff4500',  '#ff8c00',  '#ffd700', '#90ee90',  '#00ced1', '#1e90ff',  '#c71585',  'rgba(255, 69, 0, 0.68)',  'rgb(255, 120, 0)',  'hsv(51, 100, 98)', 'hsva(120, 40, 94, 0.5)', 'hsl(181, 100%, 37%)', 'hsla(209, 100%, 56%, 0.73)','#c7158577']">
          </el-color-picker>
        </el-form-item>

        <el-form-item label="字体大小">
          <el-input-number v-model="ele.option.fontSize"></el-input-number>
        </el-form-item>

        <el-form-item label="字体样式">
          <el-select v-model="ele.option.fontWeight">
            <el-option label="普通" value="normal"></el-option>
            <el-option label="加粗" value="bold"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="布局">
          <el-select v-model="ele.option.textAlign">
            <el-option value="left" label="居左"></el-option>
            <el-option value="right" label="居右"></el-option>
            <el-option value="center" label="居中"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="下划线">
          <el-switch v-model="ele.option.textDecoration" active-color="#55aaff"
                     inactive-color="#cfcfcf" active-value="underline" inactive-value="none">
          </el-switch>
        </el-form-item>

      </el-collapse-item>

      <el-collapse-item name="阴影" title="阴影">
        <el-form-item label="阴影颜色">
          <el-color-picker v-model="ele.option.textShadowColor" show-alpha
                           :predefine="['rgba(255, 255, 255, 1.0)','#ff4500',  '#ff8c00',  '#ffd700', '#90ee90',  '#00ced1', '#1e90ff',  '#c71585',  'rgba(255, 69, 0, 0.68)',  'rgb(255, 120, 0)',  'hsv(51, 100, 98)', 'hsva(120, 40, 94, 0.5)', 'hsl(181, 100%, 37%)', 'hsla(209, 100%, 56%, 0.73)','#c7158577']">
          </el-color-picker>
        </el-form-item>

        <el-form-item label="阴影大小">
          <el-input-number v-model="ele.option.textShadowSize"></el-input-number>
        </el-form-item>
      </el-collapse-item>

    </el-collapse>
  </el-form>

</template>

<script>

export default {
  components: {},
  props: {
    element: {
      type: Object,
      default: () => {
      }
    },
    report: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      ele: null
    }
  },
  created() {
    this.ele = this.element;
  },
  methods: {
  }


}

</script>

<style scoped lang="scss">

</style>